<template>
  <div style="display: inline-block">
    <v-tooltip top>
      <template #activator="{on}">
        <span v-on="on" @click="dialog = true">
          <slot>
            <v-btn icon v-if="$store.state.DelegationOrder.readonly !== true"><v-icon>fa-file-import</v-icon></v-btn>
          </slot>
        </span>
      </template>
      {{ $t("delegationOrder.importTravelServiceOrders") }}
    </v-tooltip>
    <v-dialog v-model="dialog">
      <v-card>
        <v-card-title>
          {{ $t("travelService.orderList") }}
          <v-spacer />
          <v-col cols="12" md="4"><v-text-field v-model="search" :label="$t('global.search')"/></v-col>
        </v-card-title>
        <v-card-text>
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="travelServiceOrdersWithoutAlreadyImported"
            item-key="id"
            :search="search"
            :custom-filter="filterOverAllProperty"
          >
            <template #item="props">
              <tr>
                <td>
                  <v-checkbox v-model="props.selected" hide-details style="width: 5px;" class="mt-0" />
                </td>
                <td>{{ props.item.created_at }}</td>
                <td class="text-center">{{ getStatusText(props.item) }}</td>
                <td class="text-center">
                  <order-services-request-dates :order-service-item="orderItem" v-for="orderItem of props.item.travelServiceOrderItems" :key="orderItem.id" />
                </td>
                <td class="text-center" v-html="getServicesHtml(props.item)"></td>
                <td class="text-center" v-html="getPersonsHtml(props.item)"></td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions
          ><v-spacer />
          <v-btn text @click="dialog = false" color="blue darken-1">{{ $t("global.cancel") }}</v-btn>
          <v-btn text color="blue darken-1" @click="importOrder">{{ $t("global.import") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { itemsFilterStatus } from "../../staticData/ServiceOrder";
import filterOverAllProperty from "../../repository/filterOverAllProperty";
import OrderServicesRequestDates from "../TravelService/OfferPresentation/Partial/OrderServicesRequestDates";
export default {
  name: "DelegationOrderTravelServiceImport",
  components: { OrderServicesRequestDates },
  props: {
    travel_service_order_ids: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    dialog: false,
    travelServiceOrders: [],
    selected: [],
    search: null
  }),
  methods: {
    filterOverAllProperty,
    importOrder() {
      let array = this.travel_service_order_ids;
      for (let item of this.selected) {
        array.push(item.id);
      }
      this.selected = [];
      this.$emit("update:travel_service_order_ids", array);
      this.dialog = false;
    },
    downloadTravelServiceList() {
      this.axios.get("/travel-service/get-service-order-list-delegation-order").then(resp => {
        this.travelServiceOrders = resp.data;
      });
    },
    getStatusText(item) {
      return this.itemsFilterStatus.find(types => types.value === item.status).text;
    },
    getServicesHtml(item) {
      let html = "";
      for (let serviceItem of item.travelServiceOrderItems) {
        html += "<b>" + this.$t("travelService.types." + serviceItem.type) + "</b>";
        if (typeof serviceItem.name !== "undefined") {
          html += " " + serviceItem.name;
        }
        if (typeof serviceItem.locationText !== "undefined") {
          html += " " + serviceItem.locationText;
        }
        if (typeof serviceItem.startLocationText !== "undefined") {
          html += " " + serviceItem.startLocationText;
        }
        if (typeof serviceItem.endLocationText !== "undefined" && serviceItem.endLocationText !== null) {
          html += "-" + serviceItem.endLocationText;
        }

        html += "<br/>";
      }
      return html;
    },
    getPersonsHtml(item) {
      let fullNames = [];

      for (let serviceItem of item.travelServiceOrderItems) {
        for (let user of serviceItem.travelServiceOrderItemPassengers) {
          if (!fullNames.includes(user.name + " " + user.surname)) fullNames.push(user.name + " " + user.surname);
        }
      }

      let html = "<ul>";
      for (let fullName of fullNames) {
        html += "<li>" + fullName + "</li>";
      }
      html += "</ul>";
      return html;
    }
  },
  computed: {
    headers() {
      return [
        { text: "", sortable: false, width: "1%" },
        {
          text: this.$t("travelService.headers.createdAt"),
          align: "left",
          value: "created_at"
        },
        { text: "Status", value: "status", align: "center" },
        { text: this.$t("travelService.headers.dates"), sortable: false, align: "center" },
        { text: this.$t("travelService.headers.services"), sortable: false, align: "center" },
        { text: this.$t("global.passengers"), sortable: false, align: "center" }
      ];
    },
    itemsFilterStatus,
    travelServiceOrdersWithoutAlreadyImported() {
      return this.travelServiceOrders.filter(v => !this.travel_service_order_ids.includes(v.id));
    }
  },
  mounted() {
    this.downloadTravelServiceList();
  }
};
</script>

<style scoped></style>
